/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/home/desktop.app.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'home/desktop.app', exports: {} };
const exports = module.exports;



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_carousel as fdCarousel } from '@take-2/fd-modules/splits/require-global';



import spotlightContent from '@take-2/fd-modules/home/desktop/spotlightContent';



import marketingSpotlight from '@take-2/fd-modules/shared/desktop/marketingSpotlight';



import theatersModule from '@take-2/fd-modules/home/desktop/theatersModule';



import { shared_global_globalTooltipModule as globalTooltipModule } from '@take-2/fd-modules/splits/require-global';



import promoCodeTout from '@take-2/fd-modules/shared/global/promoCodeTout';



import abTest6254 from '@take-2/fd-modules/test/abTest6254';



const Selectors = {
    NAV_CONTAINER: '.nav_container', // For global tooltip positioning
}


const Classes = {
    GLOBAL_TOOLTIP_HOME_DESKTOP: 'global-tooltip__container--home-desktop',
}


const carouselOpts = {
    autoWidth: true,
    padding: { left: 0, right: 0 }
}


const tooltipOpts = {
    selector: Selectors.NAV_CONTAINER,
    page: globalTooltipModule.Pages.HOME,
    overrideClass: Classes.GLOBAL_TOOLTIP_HOME_DESKTOP,
    autodismiss: true,
}
function run() {
    checkDependencies(module.name, debugLog);
    fdCarousel.init('movie-carousel', carouselOpts);
    fdCarousel.init('featured-carousel');
    fdCarousel.init('coming-soon-carousel', carouselOpts);
    fdCarousel.init('at-home-carousel', carouselOpts);
    marketingSpotlight.init();
    promoCodeTout.init();
    spotlightContent.init();
    theatersModule.init();
    globalTooltipModule.initOverlay(tooltipOpts);
    abTest6254.run();
}
run();
export default {  };